import { createSlice } from "@reduxjs/toolkit"
import { createActions } from "@helper"
import * as actions from '../action'

const initialState = {
    params: {
        type: 1,
        conditionContent: ''
    },
    page: {
        pageNum: 1,
        pageSize: 20,
        total: 0
    },
    qaBasicList: [], // 基础问答列表
	timeParams: {
		pageNum: 1,
		pageSize: 10,
		timeId: '',
		timeName: ''
	}
}

const reducers = createActions({
    setParams: (state, action) => {
        const { params, ...other} = state
        return { ...other, params: {...params, ...action.payload}}
    },
    queryKnowledgeRulePageAction: {
        pending: (state, action) => {
            const { meta: {arg: {data} } } = action
            const { pageNum, pageSize, ...otherParams }= data

            return {
                ...state,
                params: {...otherParams},
                page: {...state.page, pageNum, pageSize}
            }
        },
        success: (state, action) => {
            const { total, list } = action.payload
            return {
                ...state,
                page: { ... state.page, total },
                qaBasicList: list
            }
        }
    },
	setTimeParams: (state, action) => {
		const { timeParams, ...other } = state
		return { ...other, timeParams: { ...timeParams, ...action.payload } }
	}
}, actions)

const qaBasicSlice = createSlice({
    name: 'qaBasic',
    initialState,
    ...reducers
})

export const getPages = state => state.qaBasic.page
export const getParams = state => state.qaBasic.params
export const getQaBasicList = state => state.qaBasic.qaBasicList
export const getTimeParams = state => state.qaBasic.timeParams

export const { setParams, setTimeParams } = qaBasicSlice.actions
export default qaBasicSlice
